import React, { Component } from 'react';
import { PGService } from '../../Remote/PowerGym';
import { hideLoadingBar, showLoadingBar } from "../../Redux/actions/loading";
import { showSnackbar } from "../../Redux/actions/snackbar";
import { connect } from "react-redux";
import UserData from "./UserData/UserData";
import InstanceData from "./InstanceData/InstanceData";
import Memberships from './Memberships/Memberships';
import AsLinkCard from '../LinkAccount/AsLinkCard';

class HomePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            profileData: null
        }

    }

    componentDidMount() {
        this.props.showLoadingBar();

        PGService.profile().then(response => {
            this.setState({
                profileData: response
            });
            this.props.hideLoadingBar();
        });
    }


    render() {
        const { profileData } = this.state;
        const { instance } = this.props;
        if (!profileData || !instance) {
            return <p>Cargando...</p>;
        }

        return (
            <div>
                <InstanceData instance={instance} />
                <br />
                {profileData.as_link && <AsLinkCard asLink={profileData.as_link} />}
                <UserData user={{
                    ...profileData.user,
                    remainingFichas: profileData.remainingFichas
                }} next_booking={profileData.next_booking} />
                <br />
                {profileData.activeMemberships && <Memberships activeMemberships={profileData.activeMemberships} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading,
    instance: state.instance.data
});

const mapDispatchToProps = dispatch => ({
    showLoadingBar: () => dispatch(showLoadingBar()),
    hideLoadingBar: () => dispatch(hideLoadingBar()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
